<template>
    <div>
        <swiper
            :options="swiperOption"
            ref="mySwiper1"
        >
            <swiper-slide
                v-for="(item, index) in articleRes"
                :key="index"
            >
                <ArticleMain
                    :article="item"
                    :gaInfo="gaInfo"
                    class="mb-3"
                />
            </swiper-slide>
            <div
                class="swiper-button-prev"
                slot="button-prev"
            />
            <div
                class="swiper-button-next"
                slot="button-next"
            />
            <div
                class="swiper-pagination"
                slot="pagination"
            />
        </swiper>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ArticleMain from '@/components/ArticleMain.vue';

export default {
    name: 'SliderMainArticle',
    components: {
        swiper,
        swiperSlide,
        ArticleMain,
    },
    props: {
        articleRes: {
            type: Array,
            require: true,
        },
        gaInfo: { type: String, default: '健康及保險知識+|' },
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
        };
    },
    computed: {
        // swiper() {
        //     return this.$refs.mySwiper1.swiper;
        // },
    },
    mounted() {
        // this.swiper.slideTo(3, 1000, false);
    },
    methods: {
        goToPage(link) {
            if (link) {
                window.open(link);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.swiper-slide {
    width: 100%;
}
@mixin arrow($deg: -45deg) {
    border: solid black;
    border-width: 0px 3px 3px 0;
    display: inline-block;
    width: 16px;
    height: 16px;
    padding: 3px;
    transform: rotate($deg);
    border-color: #2c8db9;
    opacity: 1;
    background: none;
}
::v-deep {
    .swiper-button-prev, .swiper-button-next {
        top:  calc(23vw + 30px);;
        @include media-breakpoint-up(md) {
            top: calc(18vw - 15px);
        }
        @include media-breakpoint-up(xl) {
            top: 213px;
        }
    }
    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
        @include arrow(135deg);
    }
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
        @include arrow;
    }
    .swiper-button-prev.swiper-button-disabled,
    .swiper-button-next.swiper-button-disabled {
        border-color: #999;
        opacity: 0;
    }
    .swiper-container-horizontal
        > .swiper-pagination-bullets
        .swiper-pagination-bullet {
        margin: 0 8px;
    }
    .swiper-pagination-bullet {
        width: 15px;
        height: 15px;
        background-color: $white;
        opacity: 1;
        border: 1px solid #e7e7e7;
    }
    .swiper-pagination-bullet-active {
        background-color: $primary;
        border: 1px solid $white;
    }
    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal > .swiper-pagination-bullets {
        top: calc(47vw - 30px);
        height: 2rem;
        @include media-breakpoint-up(sm) {
            top: calc(48vw - 30px);
        }
        @include media-breakpoint-up(md) {
            top: 24vw;
        }
        @include media-breakpoint-up(md) {
            top: 24.5vw;
        }
        @include media-breakpoint-up(xl) {
            top: 295px;
        }
    }
}
</style>
